<template>
  <el-dialog
      :close-on-click-modal="false"
      :title="ModalBaslik"
      :visible.sync="Durum"
      :before-close="Kapat"
      :v-loading="lo"
  >
    <el-form v-loading="lo" status-icon :model="Form" @submit.prevent.native="Gonder" :rules="FormHata"
             ref="Form">
      <el-row :gutter="24">
        <el-col :span="16">
          <el-form-item label="Bina Adı" prop="adi">
            <el-input type="text" v-model="Form.adi" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Bölge" prop="Bolge_id">
            <el-select v-model="Form.Bolge_id" filterable placeholder="Bölge Seçiniz">
              <el-option
                  v-for="item in Bolgeler"
                  :key="item.id"
                  :label="item.adi"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Vergi Dairesi" prop="vDaire">
            <el-input type="text" v-model="Form.vdaire" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Vergi No" prop="vNo">
            <el-input type="text" v-model="Form.vno" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="Bakım Günü" prop="gun">
            <el-input type="text" v-model="Form.gun" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Cari Kod" prop="kod">
            <el-input type="text" v-model="Form.kod" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Kordinat" prop="kod">
            <el-input type="text" v-model="Form.kordinat" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="Adres" prop="adres">
            <el-input type="textarea" v-model="Form.adres" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider content-position="left">Yönetici Bilgileri</el-divider>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="Ad Soyad" prop="yad">
            <el-input type="text" v-model="Form.yadi" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Telefon" prop="ytel">
            <el-input type="text" v-mask="'### ### ## ##'" v-model="Form.ytelefon" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>


    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="Kapat">İptal</el-button>
      <el-button size="small" type="primary" :loading="lo" @click="Gonder">Kaydet</el-button>
    </div>
  </el-dialog>

</template>

<script>
export default {
  props: ['Bilgi', 'Durum', 'Tur'],
  data() {
    return {
      ModalBaslik: '',
      lo: false,
      Form: null,
      Bolgeler: null,
      FormHata: {
        adi: [{required: true, message: "Bina Adı Giriniz", trigger: 'blur'}],
        Bolge_id: [{required: true, message: "Bölge Seçiniz", trigger: 'blur'}],
        adres: [{required: true, message: "Adres Giriniz", trigger: 'blur'}],
      },
    }
  },
  methods: {
    Kapat() {
      this.$emit('Durum')
    },
    Gonder() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true

          this.$store.dispatch(this.Tur, {...this.Form, path: 'build'})
              .then(response => {
                console.log(response)
                if (response.Durum == "OK") {
                  this.$emit('Durum')
                  this.$notify.success({
                    title: response.Mesaj,
                    customClass: 'success'
                  });
                  this.lo = false
                  if (this.Tur == 'Post') this.$router.push("/bina/" + response.Build_id);
                } else {
                  this.$notify.error({
                    title: response.Mesaj,
                    customClass: 'error'
                  });
                  this.lo = false
                }
              })
        }
      })

    }
  },
  created() {
    if (this.Bilgi) {
      this.Form = this.Bilgi
      this.ModalBaslik = this.Bilgi.Unvan
    } else {
      this.Form = {}
      this.ModalBaslik = 'Bina Ekle'
    }
    this.$store.dispatch("Get", {path: 'bolge'})
        .then(response => {
          this.Bolgeler = response.Data
        })
  },
  watch: {
    Bilgi: function () {
      this.Form = this.Bilgi
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Bina/Comp/BinaModal.vue